// extracted by mini-css-extract-plugin
module.exports = {"FullscreenOverlay":"FullscreenOverlay_FullscreenOverlay__hN8-K"};